import { ref, computed } from 'vue'
import { actionButtonStateInfoData } from '@/common/util/player.action.button'
import { indexOf } from 'lodash'
import {
  ACTION_DISPLAY,
  ACTION_STATE,
  CONTENT_STATUS,
} from '@/common/util/action-button/const'
import { useRouterComposable } from '@/common/use/useRouterComposable'
import { PATH_NAME_VOUCHER_POPUP_NEW_FOR_APP } from '@/common/router.const'

export const usePlayerActionButton = (streamStatus) => {
  const { pushRouter, replaceRouter } = useRouterComposable()
  const isButtonDisabled = ref(false)
  const isLoading = ref(false)
  const status = ref(streamStatus)
  const episodeNumber = ref('0')

  const STREAM_DISPLAY = {
    CONTINUE: '이어보기',
    NORMAL: computed(() => `에피소드 ${episodeNumber.value} 보기`),
    LATEST: computed(() => `최신 에피소드 ${episodeNumber.value} 보기`),
    BEGIN: '처음부터 보기',
  }

  /**
   * action 이 stream 일 경우 버튼 디스플레이 상태 반환
   * @param displayState // = STREAM_DISPLAY
   * @returns {string}
   */
  const getStreamButtonDisplay = (displayState = '') => {
    switch (displayState) {
      case CONTENT_STATUS.CONTINUE:
        return STREAM_DISPLAY.CONTINUE

      case CONTENT_STATUS.NORMAL:
        return STREAM_DISPLAY.NORMAL.value

      case CONTENT_STATUS.LATEST:
        return STREAM_DISPLAY.LATEST.value

      case CONTENT_STATUS.BEGIN:
        return STREAM_DISPLAY.BEGIN
    }
  }

  /**
   * action button 초기화 (get permission for content 호출)
   * @param contentType
   * @param contentInfo
   * @returns {Promise<{display: (string|string), action: string}>}
   */
  const getActionButton = async ({ contentType, contentInfo }) => {
    isLoading.value = true
    episodeNumber.value = contentInfo?.episodenumber?.replace('회', '') ?? ''

    try {
      const data = await actionButtonStateInfoData(contentType, contentInfo)
      const { isVisible = false, title = '', action = '' } = data
      const IS_STREAM = action === ACTION_STATE.STREAM

      isLoading.value = isVisible

      return {
        action,
        display: IS_STREAM ? getStreamButtonDisplay(status.value) : title,
      }
    } catch (e) {
      console.error(`Error Action Button State Info Data :${e.message}`)

      return {
        action: ACTION_STATE.NONE,
        display: ACTION_DISPLAY.DISABLE,
      }
    }
  }

  /**
   * 로그인 팝업 호출
   */
  const actionLogin = (routeFullPath = '') => {
    replaceRouter(`/member/login?referer=${routeFullPath}`)
  }

  /**
   * 구매 팝업 호출
   * @param contentType
   * @param contentInfo
   */
  const actionPurchase = (contentType, contentInfo) => {
    const IS_MOVIE = contentType === 'movie'
    const {
      contentid: contentId = '',
      movieid: movieId = '',
      programid: programId = '',
      channelid: channelId = '',
      cpid: cpId = '',
      moviemarks: movieMarks = [],
    } = contentInfo

    const type = IS_MOVIE ? 'movie' : 'voucher'
    const playy = indexOf(movieMarks, 'playy') > -1 ? 'y' : 'n'

    const query = {
      type,
      contenttype: contentType,
      channelid: channelId,
      contentid: IS_MOVIE ? movieId : contentId,
      programid: IS_MOVIE ? movieId : programId || contentId,
      cpid: cpId,
    }

    if (IS_MOVIE) {
      Object.assign(query, { playy })
    }

    pushRouter({
      name: PATH_NAME_VOUCHER_POPUP_NEW_FOR_APP,
      query,
    })
  }

  return {
    isButtonDisabled,
    isLoading,
    episodeNumber,
    getStreamButtonDisplay,
    getActionButton,
    actionLogin,
    actionPurchase,
  }
}
